enum BusinessStatus {
  NOT_CONNECTED = "NOT_CONNECTED",
  CONNECTED = "CONNECTED",
  REJECTED = "REJECTED",
  EXPIRE = "EXPIRE",
}

export default BusinessStatus;
